import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkbox']

  select (event) {
    if (!event.target.checked) return

    this.checkboxTargets
      .filter(cb => cb !== event.target)
      .forEach(cb => { cb.checked = false })
  }
}
